import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import UnpinIcon from "@entrilia/shared/icons/UnpinIcon.tsx";

interface Props {
  label: string;
  unfreezeColumn: (event: React.MouseEvent<HTMLElement>) => void;
}

const UnfreezeMenuItem = ({ label, unfreezeColumn }: Props) => {
  return (
    <MenuItem onClick={unfreezeColumn}>
      <ListItemIcon>
        <UnpinIcon fontSize="small" color="primary" />
      </ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};

export default UnfreezeMenuItem;
